import { render, staticRenderFns } from "./VueComponentsTable.vue?vue&type=template&id=38b85c7c"
import script from "./VueComponentsTable.js?vue&type=script&lang=js&external"
export * from "./VueComponentsTable.js?vue&type=script&lang=js&external"
import style0 from "./VueComponentsTable.vue?vue&type=style&index=0&id=38b85c7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports